import React from 'react';
import './QuizTimer.css';

interface QuizTimerProps {
  timeLeft: number;
  totalTime: number;
  isActive: boolean;
}

const QuizTimer: React.FC<QuizTimerProps> = ({ timeLeft, totalTime, isActive }) => {
  const percentage = (timeLeft / totalTime) * 100;
  
  const getTimerColor = () => {
    if (percentage > 50) return "#4facfe";
    if (percentage > 25) return "#f093fb";
    return "#ff6b6b";
  };

  const getTimerMessage = () => {
    if (timeLeft > 20) return "Čas je na tvoji strani!";
    if (timeLeft > 10) return "Hitro, hitro!";
    if (timeLeft > 5) return "Zadnji trenutki!";
    return "Čas se izteka!";
  };

  return (
    <div className="timer-container">
      <div className="timer-header">
        <div className="timer-display">
          <span className="time-left">{timeLeft}</span>
          <span className="time-unit">s</span>
        </div>
      </div>
      
      <div className="timer-bar-container">
        <div 
          className="timer-bar"
          style={{ 
            width: `${percentage}%`,
            backgroundColor: getTimerColor()
          }}
        />
      </div>
      
      {isActive && (
        <div className="timer-message" style={{ color: getTimerColor() }}>
          {getTimerMessage()}
        </div>
      )}
    </div>
  );
};

export default QuizTimer;
